import React, { Component } from 'react';
import cookie from '../../src/cookiecut.png';
import { Button } from '@blueprintjs/core';
import{withRouter,Link} from 'react-router-dom';
import {inject} from 'mobx-react';
import Whynowrite from '../component/whynotwrite'


@withRouter
@inject("store")

export default class Story extends Component
{
    noidea(){
        this.props.store.whynowrite= true;
        this.forceUpdate();
    }

    noready(){
        this.props.store.whynowrite= false;
        this.forceUpdate();
    }

    improve(){
        this.props.store.upsetwith = "nothing";
        this.forceUpdate();
        this.props.history.push("/improve");
    }
  
    render()
    {
        return <div className = "story">
              <img src={cookie} className="cookiepicture" alt="cookie" />
              <br/>
              <div className = "storytext"><Whynowrite /></div>
              {this.props.store.whynowrite == "nothing"?<> <Button icon="arrow-right" className="Button" minimal={true}  onClick={()=>this.noidea() } >不知道写些什么</Button><br/>
              <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.noready() }>想要好好学习，之后再写</Button><br/>
              <Button icon="arrow-right" className="Button" minimal={true}  onClick={()=>this.improve()}>我想起来了，其实写过的</Button><br/></>
            :<></>}
            
             



        </div>;
    }
} 